import MarkDown from "react-markdown"

export const Project = (props: any) => {
    return (
        <div className='info' key={props?.item?.$qid}>
            {props?.item?.projectName && (
                <div className='width-inline'>
                    <span className='label f-bold m-b-0-5'>
                        {props.translation(
                            'climate.projectNameLabel'
                        )}:&nbsp;
                    </span>
                    <span className='data m-b-1 markdown-wrapper'>
                        <MarkDown
                            components={{
                                a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />
                            }}
                        >
                            {props?.item?.projectName}
                        </MarkDown>
                    </span>
                </div>
            )}
            {props?.item?.projectLocation && (
                <div className='width-inline'>
                    <span className='label f-bold m-b-0-5'>
                        {props.translation(
                            'climate.projectLocationLabel'
                        )}:&nbsp;
                    </span>
                    <span className='data m-b-1'>
                        {props?.item?.projectLocation}
                    </span>
                </div>
            )}
            {props?.item?.projectType && (
                <div className='width-inline'>
                    <span className='label f-bold m-b-0-5'>
                        {props.translation(
                            'climate.projectTypeLabel'
                        )}:&nbsp;
                    </span>
                    <span className='data m-b-1'>
                        {props?.item?.projectType}
                    </span>
                </div>
            )}
            {props?.item?.projectStandard && (
                <div className='width-inline'>
                    <span className='label f-bold m-b-0-5'>
                        {props.translation(
                            'climate.projectStandardLabel'
                        )}:&nbsp;
                    </span>
                    <span className='data m-b-1'>
                        {props?.item?.projectStandard}
                    </span>
                </div>
            )}
            {props?.item?.totalEmissions && (
                <div className='width-inline'>
                    <span className='label f-bold m-b-0-5'>
                        {props.translation(
                            'climate.co2EmissionLabel'
                        )}:&nbsp;
                    </span>
                    <span className='data m-b-1'>
                        {props?.item?.totalEmissions}{props?.item?.emissionYear && ` ${props.translation('climate.emissionInLabel')} ${props?.item?.emissionYear}`}
                    </span>
                </div>
            )}
            {props?.item?.projectImage?.URL && (
                <div className='width-inline project-image-wrapper'>
                    <img
                        src={props?.item?.projectImage?.URL}
                        alt={props?.item?.projectName}
                        className='project-image'
                    />
                </div>
            )}
        </div>
    )
}